"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var CustomIconButtons_1 = require("atomicComponents/molecules/IconButtons/CustomIconButtons");
var IconButtons_1 = require("atomicComponents/molecules/IconButtons/IconButtons");
var InvalidSpendToggle = function (_a) {
    var isHudledInvalid = _a.isHudledInvalid, isPartialView = _a.isPartialView, onClick = _a.onClick, isSending = _a.isSending;
    return ((0, jsx_runtime_1.jsx)(Box_1.default, __assign({ component: "span", height: 80, pl: 1.5, pr: 1, py: 3, lineHeight: "1", position: "absolute", top: 0, right: -48, display: isPartialView ? 'none' : 'block' }, { children: !isHudledInvalid
            ? (0, jsx_runtime_1.jsx)(CustomIconButtons_1.InvalidSpendIconButton, { outlined: true, onClick: onClick, disabled: isSending, sx: { visibility: 'hidden' } })
            : (0, jsx_runtime_1.jsx)(IconButtons_1.DollarSignButton, { outlined: true, onClick: onClick, disabled: isSending, sx: { visibility: 'hidden' } }) })));
};
exports.default = InvalidSpendToggle;
